import React from 'react';

import { Box } from '@betterment/samba-react';
import { NavLink } from 'react-router-dom';

import { Nav } from '../../../../Shared/components-v2/nav/nav';
import { navItemStyles } from '../../../../Shared/components-v2/nav/nav-link-styles';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../../hooks/useProcessNavTransition';
import { EnvelopesQuery } from '../graphql/query.envelopes.generated';

type Envelope = EnvelopesQuery['envelopes'][number];
type Account = Envelope['accounts'][number];

const AccountItemContent: React.FC<{ account: Account; subtitle?: string }> = ({ account, subtitle }) => {
  return (
    <>
      <Nav.Icon asChild={true}>
        <img src={account.icon.dark} alt="" />
      </Nav.Icon>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Nav.Text>{account.name}</Nav.Text>
        {subtitle && <Nav.Subtext>{subtitle}</Nav.Subtext>}
      </Box>
    </>
  );
};

export const AccountItem: React.FC<{ account: Account }> = ({ account }) => {
  const onClick = useProcessNavTransition();

  const { url, subtitle } =
    account.__typename === 'CheckingAccount'
      ? {
          url: account.remote && urlBuilder.getAppCheckingSummary({ accountId: account.remote.checkingAccountId }),
          subtitle: account.remote ? undefined : 'Unavailable',
        }
      : { url: urlBuilder.appAccount({ accountId: account.id }), subtitle: undefined };

  return url ? (
    <NavLink
      key={account.id}
      className={navItemStyles({ spacing: subtitle ? 'default' : 'expanded' })}
      to={url}
      onClick={onClick}
      data-turbolinks="false"
    >
      <AccountItemContent account={account} subtitle={subtitle} />
    </NavLink>
  ) : (
    <Box css={navItemStyles.raw({ spacing: subtitle ? 'default' : 'expanded' })}>
      <AccountItemContent key={account.id} account={account} subtitle={subtitle} />
    </Box>
  );
};
